'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VersionMessage;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _localizationMessageIfExists = require('@bibliocommons/localization-message-if-exists');

var _localizationMessageIfExists2 = _interopRequireDefault(_localizationMessageIfExists);

require('../styles/VersionMessage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VersionMessage(_ref) {
  var version = _ref.version;

  return _react2.default.createElement(
    'div',
    { className: 'cp-version-message' },
    _react2.default.createElement(
      'p',
      { className: 'powered-by' },
      _react2.default.createElement(_localizationMessageIfExists2.default, { id: 'static_powered_by', component: _reactIntl.FormattedHTMLMessage })
    ),
    _react2.default.createElement(
      'p',
      { className: 'product-version' },
      'NERF: ',
      version
    )
  );
}

VersionMessage.displayName = 'VersionMessage';
VersionMessage.propTypes = {
  version: _react.PropTypes.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/version-message/lib/components/VersionMessage.component.js
// module id = 1570
// module chunks = 1